import { useEffect, useState, useRef } from 'react'

const exchangeSocketURL = 'wss://ws-feed.exchange.coinbase.com'

const useBitcoinPrice = () => {
  const [price, setPrice] = useState<number | null>(null)
  const socketRef = useRef<WebSocket | null>(null)
  const reconnectTimeoutRef = useRef<number | null>(null)

  const connectWebSocket = () => {
    const ws = new WebSocket(exchangeSocketURL)
    socketRef.current = ws

    ws.onopen = () => {
      const subscribeMessage = JSON.stringify({
        type: 'subscribe',
        channels: [{ name: 'ticker', product_ids: ['BTC-USD'] }],
      })
      ws.send(subscribeMessage)
    }

    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data)

        if (data.type === 'ticker' && data.price) {
          setPrice(+data.price)
        }
      } catch (error) {
        console.error('Error parsing message:', error)
      }
    }

    ws.onclose = () => {
      reconnect()
    }

    ws.onerror = (error) => {
      ws.close()
    }
  }

  const reconnect = () => {
    if (reconnectTimeoutRef.current) return

    reconnectTimeoutRef.current = window.setTimeout(() => {
      connectWebSocket()
      reconnectTimeoutRef.current = null
    }, 5000)
  }

  const fetchBackupPrice = async () => {
    try {
      const response = await fetch(
        'https://api.exchange.coinbase.com/products/BTC-USD/ticker'
      )
      const data = await response.json()
      if (data.price) {
        setPrice(+data.price)
      }
    } catch (error) {
      console.error('Error fetching backup price:', error)
    }
  }

  useEffect(() => {
    connectWebSocket()

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        if (socketRef.current?.readyState !== WebSocket.OPEN) {
          connectWebSocket()
        } else {
          fetchBackupPrice()
        }
      } else {
        socketRef.current?.close()
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
      if (socketRef.current) {
        socketRef.current.close()
      }
      if (reconnectTimeoutRef.current) {
        clearTimeout(reconnectTimeoutRef.current)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return price
}

export default useBitcoinPrice
